import {productUrlBuilder, categoryUrlBuilder} from '@salesforce/retail-react-app/app/utils/url'

export * from '@salesforce/retail-react-app/app/utils/url'

export const pageUrlBuilder = (page) => encodeURI(`/page-viewer/${page.id}`)

export const generalUrlBuilder = (obj) => {
    switch (obj?.linkType) {
        case 'Page':
            return pageUrlBuilder(obj)
        case 'Product':
            return productUrlBuilder(obj)
        case 'Category':
            return categoryUrlBuilder(obj)
        case 'External':
            // TODO check how we can handle absolute URLs
            return obj.href
        case 'Static':
            // TODO check how we can handle absolute URLs
            return obj.href
        case 'Blog':
            return pageUrlBuilder({linkType: 'Page', id: 'blog'})
        case 'ContactUs':
            return '/contact'
        default:
            return '/'
    }
}
